import { datadogRum } from '@datadog/browser-rum'
import { BarcodeDetector } from '../types'

declare global {
  interface Window {
    isBarcodeDetectorNative: boolean | undefined

    // reason: not going to import the ZXingBarcodeDetector above, since we import it conditionally
    // else our package becomes too big
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BarcodeDetector: BarcodeDetector | any
  }
}

// TODO: Refactor this legacy, maybe even use another library
const featureFlag = 'hardwareBarcodeScannerFeatureFlagV2'

// Callers may start this at boot and await it again on first use, so only ever run it once.
let pending: Promise<void> | undefined

export const loadPolyfills = (
  /**
   * Skip the feature check where it imports the polyfills based on the
   * value of a local storage key.
   */
  noFeatureCheck?: boolean
): Promise<void> => {
  pending ??= new Promise<void>((resolve) => {
    const doImport = () => {
      datadogRum.addAction('is-scanner-native', { message: 'No' })

      import('./ZXingBarcodeDetector')
        .then((module) => {
          window.isBarcodeDetectorNative = false
          window.BarcodeDetector = module.default

          resolve()
        })
        .catch((err) => {
          datadogRum.addAction('is-scanner-native', { message: `Failed: ${err.message}` })

          // When polyfill fails, resolve anyway
          resolve()
        })
    }

    // This feature Flag seems obsolete, but since devices can potentially have it and
    // maybe these are old im leaving it in for the time being for SPA
    if (!noFeatureCheck && localStorage && localStorage.getItem(featureFlag) !== 'true') {
      doImport()
    } else if ('BarcodeDetector' in window) {
      // In Chrome these formats are available, but we just make sure it works in every browser
      window.BarcodeDetector.getSupportedFormats().then((formats: string[]) => {
        const isSupported = (format: string) => formats.includes(format)

        if (isSupported('code_39') && isSupported('code_128') && isSupported('itf') && isSupported('qr_code')) {
          datadogRum.addAction('is-scanner-native', { message: 'Yes' })

          window.isBarcodeDetectorNative = true
          resolve()
        } else {
          doImport()
        }
      })
    } else {
      doImport()
    }
  })

  return pending
}
